import React from 'react';
import { Button } from 'anf-core-react';
import ProductList from './ProductList';
import OrderTotalSummary from './OrderTotalSummary';
import Row from '../Common/Grid/Row';
import Column from '../Common/Grid/Column';
import Icon from '../Common/Icon/Icon';
import { packageGroupProps } from './props';

/**
 * PackageGroup Component
 *
 * Displays details for packages within an order.
 */
export default function PackageGroup({
  packageData,
  allOrderProducts,
  text = {},
}) {
  const {
    status,
    statusIcon,
    trackingNumber,
    trackingUrl,
    orderLineKeys,
    packageSummaryData,
  } = packageData || {};

  const packageHeaderText = text?.packageHeaderText || packageData?.packageTexts?.packageHeaderText || 'Package';
  const trackPackageText = text?.trackPackageText || packageData?.packageTexts?.trackPackageText || 'Track Package';

  // Get products for this package
  const packageProducts = allOrderProducts?.filter(
    (product) => (orderLineKeys || []).includes(product.orderLineKey),
  ) || [];

  return (
    <section className="order-item__group">
      <div className="account-block order-details-wrapper order-details__package-wrapper">
        {/* Package Header */}
        <div className="heading">
          <div className="section-header-container">
            <div className="section-heading">
              <h2 className="h3">{packageHeaderText}</h2>
            </div>
            <div className="section-heading align-right order-history__status">
              {status && (
                <>
                  {statusIcon && (
                    <Icon
                      icon={statusIcon}
                      className="order-history__status__icon"
                      data-testid="icon"
                      aria-hidden="true"
                    />
                  )}
                  <div className="h3">
                    <span className="order-history__status__text">
                      {status}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="section-divider" />
        </div>

        {/* Package Content */}
        <div className="content">
          <Row>
            {/* Package Summary */}
            <Column xs="8" md="4">
              {packageSummaryData && <OrderTotalSummary summary={packageSummaryData} />}
            </Column>

            {/* Tracking Button */}
            <Column xs="8" md="4">
              {trackingNumber && trackingUrl && (
                <Button
                  variant="tertiary-dark"
                  href={trackingUrl || ''}
                  target="_blank"
                  title={trackPackageText}
                  aria-label={trackPackageText}
                  className="package-summary__cta-button"
                  data-property="WSS_TRACK_THIS_PACKAGE"
                  isFullWidth
                >
                  {trackPackageText}
                </Button>
              )}
            </Column>
          </Row>

          {/* Product List for this Package */}
          <ProductList
            orderProducts={packageProducts}
          />
        </div>
      </div>
    </section>
  );
}

PackageGroup.propTypes = packageGroupProps;
